export default __webpack_public_path__ + "static/media/24.6c3da6d3.png";